export function observeInView(element: HTMLElement) {
  if (!element) return;

  const observer = new IntersectionObserver(
    ([entry], obs) => {
      if (entry.isIntersecting) {
        element.classList.add('in-view');
        obs.unobserve(element);
      }
    },
    {
      threshold: 0.5,
    }
  );

  observer.observe(element);
}
